// src/reducers/devOverlay.js
//
// Active-fixture-keys slice for the DevOverlayApplier (task 02). The
// slice is populated by a saga (task 02) that listens for
// @@router/LOCATION_CHANGE and parses ?devOverlay= from the URL.
//
// Why a slice rather than reading window.location directly in the
// applier: keeps the applier connect()-ed and stable. The applier
// reacts to slice changes via mapStateToProps; React-Redux's
// shallow-compare isolates it from <App>'s own re-renders.
//
// This file is dev-only by intent — in production builds, the saga
// is not registered (task 02's src/sagas/index.js change is gated)
// so SET_DEV_OVERLAY_ACTIVE_KEYS never fires and the slice stays
// at its initial state. The reducer's bytes are still in the
// production bundle (small — ~30 lines) but the slice is inert.

import { SET_DEV_OVERLAY_ACTIVE_KEYS } from '../constants/ActionTypes';

export const initialState = {
  activeFixtureKeys: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_DEV_OVERLAY_ACTIVE_KEYS:
      return {
        ...state,
        activeFixtureKeys: action.payload.keys,
      };
    default:
      return state;
  }
};
